import Tooltip from '@components/Tooltip';
import { useTranslation } from '@hooks';
import NavigationLink from './NavigationLink';

const SingleLevelItem = ({ item, disabled, ...props }) => {
    const { t } = useTranslation();
    const link = <NavigationLink item={item} disabled={disabled} {...props} />;

    return disabled ? (
        <Tooltip placement="top" title={t('common.subscriptionExpiredMsg')}>
            <div>{link}</div>
        </Tooltip>
    ) : (
        link
    );
};

export default SingleLevelItem;
